import { useSEO } from "@/hooks/useSEO";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import CategoryGrid from "./components/CategoryGrid";
import HotComics from "./components/HotComics";
import RecommendedComics from "./components/RecommendedComics";
import RankingSection from "./components/RankingSection";
import LatestUpdates from "./components/LatestUpdates";
import FAQSection from "./components/FAQSection";
import NewsletterSection from "./components/NewsletterSection";
import { siteInfo } from "@/mocks/comics";

const organizationSchema = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "韩漫屋",
  url: "https://hanmanwu.com",
  description: siteInfo.description,
  foundingDate: "2020",
  contactPoint: {
    "@type": "ContactPoint",
    email: siteInfo.email,
    contactType: "customer service",
  },
};

const websiteSchema = {
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "韩漫屋",
  url: "https://hanmanwu.com",
  description: siteInfo.description,
  potentialAction: {
    "@type": "SearchAction",
    target: "https://hanmanwu.com/search?q={search_term_string}",
    "query-input": "required name=search_term_string",
  },
};

const webpageSchema = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  name: "韩漫屋 - 免费在线韩国漫画阅读平台",
  description: "韩漫屋是专业的免费在线漫画阅读平台，为您精心准备了精彩的韩漫大全，资源多样且画质优秀，是您探索韩漫的理想起点。",
  url: "https://hanmanwu.com",
  isPartOf: {
    "@type": "WebSite",
    name: "韩漫屋",
    url: "https://hanmanwu.com",
  },
};

export default function Home() {
  useSEO({
    title: "韩漫屋 - 免费在线漫画阅读平台 | 精彩韩漫大全",
    description: "韩漫屋是专业的免费在线漫画阅读平台，为您精心准备了精彩的韩漫大全，涵盖恋爱言情、奇幻冒险、热血动作、悬疑惊悚等多种类型，资源多样且画质优秀，是您探索韩漫的理想起点。",
    keywords: "韩国漫画,免费在线漫画,精彩韩漫大全,韩漫屋,韩漫在线阅读",
    canonicalUrl: "https://hanmanwu.com",
    ogTitle: "韩漫屋 - 免费在线漫画阅读平台 | 精彩韩漫大全",
    ogDescription: "韩漫屋是专业的免费在线漫画阅读平台，为您精心准备了精彩的韩漫大全，涵盖多种类型漫画。",
    ogUrl: "https://hanmanwu.com",
    ogType: "website",
    twitterCard: "summary_large_image",
    schemaObjects: [organizationSchema, websiteSchema, webpageSchema],
  });

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <HotComics />
        <RecommendedComics />
        <RankingSection />
        <LatestUpdates />
        <FAQSection />
        <NewsletterSection />
      </main>
      <Footer />
    </>
  );
}